import styles from "./Divider.module.scss";
import DividerProps from "./DividerContent.model";

import { FunctionComponent } from "react";
import useWrapperStyles from "./hooks/useWrapperStyles";
import React from "react";

const Divider: FunctionComponent<DividerProps> = (props) => {
    const wrapperStyles = useWrapperStyles(props.content);
    const bgColor = props.settings?.backgroundColor?.color || "#d8e8c5";

    return (
        <section
            className={styles.wrapper}
            style={{ backgroundColor: bgColor }}
        >
            <div
                className={styles.content}
                style={wrapperStyles}
            >
                {/* This is intentionally left empty, it's a divider with height that visually separate blocks */}
            </div>
        </section>
    );
};

export default Divider;
